export function jsonSafeStringify(json, indents = 2) {
	try {
		return JSON.stringify(json, null, indents);
	} catch (ex) {
		// eslint-disable-next-line no-console
		console.error(`Error stringifying json:`, { json, ex });
		return undefined;
	}
}
